/**
 * Each type has the 'entry' attribute of the field component.
 */
export enum AutocompleteInsuranceType {
  CATEGORY = 'categoriaObj',
  PLAN = 'planoObj',
  INSURANCE = 'convenioObj'
}